module.exports = __webpack_public_path__ + "static/media/email.91de64c0.svg";